import transferManagerPopup from './popup/index';

export default [...transferManagerPopup];
